module.exports = __webpack_public_path__ + "static/the-narrow-corridor-af3c87087e8caa81ec538b3296e20077.jpg";